let ReportFinancialSummarySelector = class {
  limitResults (event) {
    if (document.getElementById('financial_summary_period_select') === null) {
      alert('Please select a title to report on.');
      event.preventDefault();
      return false;
    }
    if (document.getElementById('financial_summary_period_select').value === '') {
      //alert('Please select a revenue period to report on.');
      $('#report_period').show().css('display', 'inline-block');
      event.preventDefault();
      return false;
    } else {
      $('#report_period').hide().css('display', 'none');
    }
  }
};

window.sflow = window.sflow || {};
window.sflow.reportFinancialSummarySelector = new ReportFinancialSummarySelector();